import { render, staticRenderFns } from "./collection_banking.vue?vue&type=template&id=03653bfa&scoped=true&"
import script from "./collection_banking.vue?vue&type=script&lang=js&"
export * from "./collection_banking.vue?vue&type=script&lang=js&"
import style0 from "./collection_banking.vue?vue&type=style&index=0&id=03653bfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03653bfa",
  null
  
)

export default component.exports